import { Routes, Route } from 'react-router-dom';

// pages
import MainPage from '../pages/MainPage';
import ComingSoonPage from '../pages/comingsoon/ComingSoonPage';
import SignInPage from '../pages/signin/SignInPage';
import SignUpPage from '../pages/signup/SignUpPage';
import SignUpVerificationEmailPage from '../pages/signup/SignUpVerificationEmailPage';
import MyPage from '../pages/mypage/MyPage';
import ForgotPWPage from '../pages/forgotpw/ForgotPWPage';
import CheckEmailPage from '../pages/forgotpw/CheckEmailPage';
import ResetPWPage from '../pages/forgotpw/ResetPWPage';
import ResetSuccessfulPage from '../pages/forgotpw/ResetSuccessfulPage';
import FromApp from '../pages/FromApp/FromApp';

// components
import DefaultLayout from '../components/layout/DefaultLayout';
import SignLayout from '../components/layout/SignLayout';

function Router() {
    return (
        <Routes>
            <Route exact path='/' element={<DefaultLayout />}>
                <Route exact path="" element={<MainPage />} />
                <Route exact path="pricing" element={<ComingSoonPage />} />
                <Route exact path="resources">
                    <Route exact path='blog' element={<ComingSoonPage />} />
                    <Route exact path='linked-in' element={<ComingSoonPage />} />
                    <Route exact path='help-center' element={<ComingSoonPage />} />
                    <Route exact path='partner' element={<ComingSoonPage />} />
                </Route>
                <Route exact path='/' element={<SignLayout />}>
                    <Route exact path='sign-in' element={<SignInPage />}/>
                    <Route exact path='sign-up'>
                        <Route exact path=''  element={<SignUpPage />} />
                        <Route exact path='verification-email' element={<SignUpVerificationEmailPage />} />
                    </Route>
                    <Route exact path='mypage' element={<MyPage />} />
                    <Route exact path='forgot-password'>
                        <Route exact path='' element={<ForgotPWPage />} />
                        <Route exact path='check-email' element={<CheckEmailPage />} />
                        <Route exact path='reset-password' element={<ResetPWPage />} />
                        <Route exact path='reset-successful' element={<ResetSuccessfulPage />} />
                    </Route>
                </Route>
                {/* GLMP 앱에서 로그인 버튼 클릭하면 넘어오는 링크 */}
                <Route exact path='/from-app' element={<FromApp />} />
            </Route>
        </Routes>
    );
}

export default Router;